import React from 'react'
import PropTypes from 'prop-types'
import { Box, ListItem, ListItemAvatar, ListItemText, Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { get } from 'lodash'
import InvoiceStatusChip from 'components/common/chip/InvoiceStatusChip'
import { getInvoiceIsPartialStatusAndBucket } from 'utils/agingBucket'
import { deriveInvoicePeriodLabel } from 'data/billing-period/invoicePeriodLabel'
import { createDateFromString, formatDateToFEFormat } from 'utils/date'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import SendInvoiceIconButton from 'components/billing/common/SendInvoiceIconButton'
import IconButton from '@mui/material/IconButton'
import { setTakePaymentState } from 'slices/billing/agingBucketSlice'
import { useDispatch } from 'react-redux'

const RenderAgingBucketInvoiceCell = ({ row }) => {
  const dispatch = useDispatch()
  const status = get(row, 'status')
  const dueDate = get(row, 'dueDate')
  const amountPaidCents = get(row, 'amountPaidCents')
  const totalCents = get(row, 'totalCents')
  const type = get(row, 'type')
  const startDate = get(row, 'startDate')
  const endDate = get(row, 'endDate')
  const invoiceDate = get(row, 'invoiceDate')
  const invoiceNumber = get(row, 'invoiceNumber')
  const latestBatchStatus = get(row, 'latestBatchStatus ')
  const latestBatchFailure = get(row, 'latestBatchFailure')
  const { isPartial, agingBucketType } = getInvoiceIsPartialStatusAndBucket(status, dueDate, amountPaidCents, totalCents)
  const { label: title } = deriveInvoicePeriodLabel({ startDate, endDate, invoiceDate, type })

  const openTakePaymentDialog = () => {
    dispatch(
      setTakePaymentState({
        open: true,
        invoiceNumber,
      })
    )
  }

  return (
    <Box width="100%">
      <Grid container alignItems="center">
        <Grid container alignItems="center" sx={{ px: 2 }} flexWrap="nowrap" size={12}>
          <Grid size="grow">
            <ListItem disableGutters disablePadding>
              <ListItemAvatar sx={{ minWidth: 0, mr: 2 }}>
                <InvoiceStatusChip
                  status={status}
                  isPartial={isPartial}
                  agingBucketType={agingBucketType}
                  generationStatus={latestBatchStatus}
                  generationFailure={latestBatchFailure}
                />
              </ListItemAvatar>
              <ListItemText
                primary={title}
                secondary={
                  <Stack flexWrap="nowrap">
                    <Typography>{`Invoice #: ${invoiceNumber}`}</Typography>
                    <Typography>{`Invoice date: ${formatDateToFEFormat(createDateFromString(invoiceDate))}`}</Typography>
                  </Stack>
                }
                slotProps={{
                  primary: {
                    color: 'textPrimary',
                    fontWeight: 600,
                  },
                }}
              />
            </ListItem>
          </Grid>
          <Grid size="grow">
            <ListItem disableGutters disablePadding>
              <ListItemText
                primary={
                  <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
                    <IconButton onClick={openTakePaymentDialog}>
                      <AttachMoneyIcon sx={{ fontSize: '20px' }} />
                    </IconButton>
                    <SendInvoiceIconButton invoice={row} />
                  </Stack>
                }
                secondary={`Due: ${formatDateToFEFormat(createDateFromString(dueDate))}`}
                slotProps={{
                  primary: { textAlign: 'right', gutterBottom: true },
                  secondary: { textAlign: 'right', variant: 'body1' },
                }}
              />
            </ListItem>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

RenderAgingBucketInvoiceCell.propTypes = {
  row: PropTypes.object,
}

export default RenderAgingBucketInvoiceCell
